// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app.en .inline-form .el-form-item__content > label[data-v-269499c2] {\n  width: 55px;\n}\n#app.en .inline-form .el-form-item[data-v-269499c2]:nth-of-type(2) {\n  margin-left: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
